module.exports = __webpack_public_path__ + "static/media/finishing_unselected.bde0193d.svg";